<template>
    <div class="flex">
        <div class="flex bg-white rounded shadow">
            <dropdown :auto-close="false"
                      class="focus:z-10 px-4 hover:bg-gray-100 border-r focus:border-white rounded-l focus:ring md:px-6"
                      placement="bottom-start">
                <template #default>
                    <div class="flex items-baseline">
                        <span class="hidden text-gray-700 md:inline">Filter</span>
                        <svg class="w-2 h-2 fill-gray-700 md:ml-2" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 961.243 599.998">
                            <path
                                d="M239.998 239.999L0 0h961.243L721.246 240c-131.999 132-240.28 240-240.624 239.999-.345-.001-108.625-108.001-240.624-240z"/>
                        </svg>
                    </div>
                </template>
                <template #dropdown>
                    <div class="mt-2 px-4 py-6 w-screen bg-white rounded shadow-xl"
                         :style="{ maxWidth: `${maxWidth}px` }">
                        <slot/>
                    </div>
                </template>
            </dropdown>
            <input v-show="showInput" class="flex px-10 py-3 md:px-5 rounded-r focus:shadow-outline" autocomplete="off" type="text"
                   name="search"
                   placeholder="Search…" :value="modelValue"
                   @input="$emit('update:modelValue', $event.target.value)"/>
        </div>


        <slot name="dateFilter"
        ></slot>
        <button class="ml-3 text-gray-500 hover:text-gray-700 focus:text-indigo-500 text-sm" type="button"
                @click="$emit('reset')">Reset
        </button>
    </div>
</template>

<script>
import Dropdown from '@/Shared/Dropdown'

export default {


    components: {
        Dropdown,
    },
    data() {

    },
    props: {
        showInput: Boolean,
        modelValue: String,
        maxWidth: {
            type: Number,
            default: 300,
        },
    },
    emits: ['update:modelValue', 'reset'],
}
</script>
<style lang="css">
.dp-custom-input {
    display: flex;
    padding: 0.75rem 3.25rem;
    margin-left: 10px;
    border-radius: 0.25rem;
    width: auto;
}

</style>
